<template>
    <div>
        <p v-if="cfg" style="font-size: 16px;">
            <v-icon :color="cfg.iconColor" v-if="cfg.icon">{{ cfg.icon }}</v-icon>
            {{ cfg.text }}
        </p>
        <v-checkbox color="primary" class="checkbox-item" v-model="selected"
            :label="cfg.label || '下次不再提醒'"></v-checkbox>
    </div>
</template>
<script>
export default {
    name: "dialog-confirm-checkbox",
    props: {
        cfg: Object,
    },
    data() {
        return {
            selected: true
        }
    },
    watch: {
        selected(v) {
            if (typeof this.cfg.onBoxCheck === 'function') {
                this.cfg.onBoxCheck(v);
            }
        }
    }
};
</script>